import { Types } from 'store/actions/quarry_actions';

const quarryReducerDefaultState = {
  error: '',
  isSending: false,
  submitRes: '',
  statusCode: '',
  data: null,
  status: '',
};

export default (state = quarryReducerDefaultState, action) => {
  switch (action.type) {
    case Types.FETCH_OPTIONS:
      return {
        ...state,
        error: action.err,
        meta: action.result,
      };
    case Types.FETCH_META_VALS:
      return {
        ...state,
        fields: action.res,
      };
    case Types.RESET_SUCCESS:
      return {
        ...state,
        isSending: action.sending,
        submitRes: action.message,
        statusCode: action.status,
        status: null,
        message: null,
        data: null,
      };
    case Types.SUBMIT_ORDER_START:
      return {
        ...state,
        isSending: true,
        error: null,
        status: null,
      };
    case Types.SUBMIT_ORDER_SUCCESS:
      return {
        ...state,
        isSending: false,
        status: action.status,
        data: action.data,
      };
    case Types.SUBMIT_ORDER_FAIL:
      return {
        ...state,
        isSending: false,
        error: action.error,
        status: action.status,
      };
    default:
      return state;
  }
};
